import classNames from "classnames";
import { FC } from "react";

import s from "./Section.module.scss";

interface SectionProps {
  background?: boolean;
  isDiv?: boolean;
  noPadding?: boolean;
  noPaddingTop?: boolean;
  children?: React.ReactNode;
}

export const Section: FC<SectionProps> = ({
  background,
  isDiv,
  noPadding,
  noPaddingTop,
  children,
}) => {
  if (isDiv) {
    return (
      <div
        className={classNames(s.Section, {
          [s.Grey]: background,
          [s.NoPadding]: noPadding,
          [s.NoPaddingTop]: noPaddingTop,
        })}
      >
        {children}
      </div>
    );
  }

  return (
    <section
      className={classNames(s.Section, {
        [s.Grey]: background,
        [s.NoPadding]: noPadding,
        [s.NoPaddingTop]: noPaddingTop,
      })}
    >
      {children}
    </section>
  );
};
